import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { ConstantsService } from './constants.service';

@Injectable({
  providedIn: 'root'
})
export class CrmDataSourceService {
  private readonly baseUrl = '/api/crm/data-sources';

  constructor(
    private httpService: HttpService,
    private constantsService: ConstantsService
  ) {}

  getDataSources(): Observable<any> {
    const requestData = {
      API_URL: this.baseUrl,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_GET
    };
    return this.httpService.sendRequest(requestData);
  }

  getDataSourceById(id: number): Observable<any> {
    const requestData = {
      API_URL: `${this.baseUrl}/${id}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_GET
    };
    return this.httpService.sendRequest(requestData);
  }

  createDataSource(dataSourcePayload: any, userEmail: string): Observable<any> {
    const requestData = {
      API_URL: `${this.baseUrl}?userEmail=${encodeURIComponent(userEmail)}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_POST,
      BODY: dataSourcePayload
    };
    return this.httpService.sendRequest(requestData);
  }

  updateDataSource(id: number, dataSourcePayload: any, userEmail: string): Observable<any> {
    const requestData = {
      API_URL: `${this.baseUrl}/${id}?userEmail=${encodeURIComponent(userEmail)}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_PUT,
      BODY: dataSourcePayload
    };
    return this.httpService.sendRequest(requestData);
  }
}
